export const formatSalePrice = (price) => `¥${Number(price).toLocaleString('ja-JP')}（税込）`;
export const calculateDiscountRate = (regularPrice, salePrice) => Math.round((1 - Number(salePrice) / Number(regularPrice)) * 100);
export const matchesShape = (type, filter) => filter === 'all' || type === filter;
export const getPurchaseState = ({ preview, available }) => ({ disabled: preview || !available, label: preview ? '販売準備中' : available ? 'カートに追加' : '売り切れ' });
export const shouldCloseDialog = ({ key, isBackdrop }) => key === 'Escape' || isBackdrop === true;

if (typeof document !== 'undefined') {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-catalog]').forEach((catalog) => {
      if (catalog.dataset.ready) return;
      catalog.dataset.ready = 'true';
      catalog.querySelectorAll('[data-filter]').forEach((filter) => filter.addEventListener('click', (event) => {
        event.preventDefault();
        const value = filter.dataset.filter;
        catalog.querySelectorAll('[data-filter]').forEach((item) => item.setAttribute('aria-pressed', String(item === filter)));
        let count = 0;
        catalog.querySelectorAll('[data-shape]').forEach((card) => {
          card.hidden = !matchesShape(card.dataset.shape, value);
          if (!card.hidden) count++;
        });
        catalog.querySelector('[data-count]').textContent = `${count} styles`;
      }));
      catalog.querySelectorAll('[data-filter]').forEach((filter) => filter.addEventListener('keydown', (event) => {
        if (event.key === ' ') { event.preventDefault(); filter.click(); }
      }));
      catalog.querySelectorAll('[data-preview]').forEach((link) => link.addEventListener('click', (event) => {
        const detail = document.getElementById(link.dataset.preview);
        if (!detail || typeof HTMLDialogElement === 'undefined') return;
        event.preventDefault();
        const dialog = document.createElement('dialog');
        dialog.className = 'product-dialog';
        dialog.setAttribute('aria-label', link.dataset.name || '商品詳細');
        const close = document.createElement('button');
        close.type = 'button'; close.className = 'dialog-close'; close.textContent = '閉じる ×';
        close.addEventListener('click', () => dialog.close());
        const body = detail.querySelector('.detail-body').cloneNode(true);
        body.querySelectorAll('[id]').forEach((item) => item.removeAttribute('id'));
        dialog.append(close, body);
        dialog.addEventListener('click', (e) => {
          const rect = dialog.getBoundingClientRect();
          const isBackdrop = e.target === dialog && (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom);
          if (shouldCloseDialog({ isBackdrop })) dialog.close();
        });
        dialog.addEventListener('close', () => { dialog.remove(); document.body.classList.remove('dialog-open'); link.focus(); });
        document.body.append(dialog); dialog.showModal(); document.body.classList.add('dialog-open');
        close.focus();
      }));
    });
    root.querySelectorAll('img[data-fallback]').forEach((img) => {
      const fallback = () => { if (img.dataset.fallback) { const src = img.dataset.fallback; delete img.dataset.fallback; img.src = src; } };
      img.addEventListener('error', fallback, { once: true });
      if (img.complete && !img.naturalWidth) fallback();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('click', (event) => {
    const shape = event.target.closest('[data-shape-link]');
    if (shape) document.querySelector(`[data-filter="${shape.dataset.shapeLink}"]`)?.click();
    if (event.target.closest('.mobile-menu a')) event.target.closest('.mobile-menu').open = false;
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach((menu) => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-variant-select]')) return;
    const form = event.target.closest('form');
    const selected = event.target.selectedOptions[0];
    const button = form.querySelector('[name="add"]');
    const state = getPurchaseState({ preview: false, available: selected.dataset.available === 'true' });
    button.disabled = state.disabled; button.textContent = state.label;
    const price = form.closest('.product-page').querySelector('[data-product-price]');
    if (price) price.textContent = selected.dataset.price;
  });
}
